import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import ScrollToTop from "./components/ScrollToTop";
import GlobalReveal from "./components/GlobalReveal";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import CEO from "./pages/CEO";
import Web from "./pages/services/Web";
import Design from "./pages/services/Design";
import SEO from "./pages/services/SEO";
import BlogDetail from "./pages/BlogDetail";
import MobileApp from "./pages/services/Mobile";
import SoftwareDev from "./pages/services/Software";
import Ecommerce from "./pages/services/Ecommerce";
import AIAutomation from "./pages/services/Ai";
import ITConsulting from "./pages/services/Consulting";
import AIDataSolutions from "./pages/services/Data";
import GraphicDesign from "./pages/services/Graphic";
import StaffAugmentation from "./pages/services/Team";
import CyberSecurity from "./pages/services/Security";
import DigitalMarketing from "./pages/services/Marketing";
import ContentWriting from "./pages/services/Content";
import AIIntegrations from "./pages/services/AiIntegration";


/* 🔥 NEW: Animated Routes */
function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -40 }}
        transition={{ duration: 0.5 }}
      >
        <GlobalReveal>
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/ceo" element={<CEO />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/services/web" element={<Web />} />
          <Route path="/services/design" element={<Design />} />
          <Route path="/services/seo" element={<SEO />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/services/mobile" element={<MobileApp />} />
          <Route path="/services/software" element={<SoftwareDev />} />
          <Route path="/services/ecommerce" element={<Ecommerce />} />
          <Route path="/services/ai" element={<AIAutomation />} />
          <Route path="/services/consulting" element={<ITConsulting />} />
          <Route path="/services/data" element={<AIDataSolutions />} />
          <Route path="/services/graphic" element={<GraphicDesign />} />
          <Route path="/services/staff-augmentation" element={<StaffAugmentation />} />
          <Route path="/services/cyber-security" element={<CyberSecurity />} />
          <Route path="/services/marketing" element={<DigitalMarketing />} />
          <Route path="/services/content" element={<ContentWriting />} />
          <Route path="/services/ai-integration" element={<AIIntegrations />} />
        </Routes>
        </GlobalReveal>
      </motion.div>
    </AnimatePresence>
  );
}


/* 🔥 MAIN APP */
function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <AnimatedRoutes />
      <Footer />
    </Router>
  );
}

export default App;